module.exports = __webpack_public_path__ + "img/symbol_4.54c42d3b.png";